import { Box, Divider, Typography } from '@mui/material';
import { TransactionPricingOfferPayload } from 'types/graphql';

import { Flex } from 'src/components/Flex';
import { PercentageInput } from 'src/components/FormikComponents/PercentageInput';
import { useTransactionData } from 'src/hooks/useTransactionCharges';

import { CustomGridItem } from './components';
import TransactionChargeValueNonEditable from './components/TransactionChargeValueNonEditable';

interface LocalityProps {
    name: string;
    serviceType: string;
    selectedTransactionOffer: TransactionPricingOfferPayload;
}

export const Locality: React.FC<LocalityProps> = ({ name, serviceType }) => {
    const { LOCALITY_CONSTANT, ONLINE_LOCALITY_CONSTANT } = useTransactionData();

    const ONLINE_LOCALITY_OPTIONS = [
        {
            name: 'intraRegional',
            label: 'Intra Regional',
            creditCardPercentage:
                ONLINE_LOCALITY_CONSTANT.intraRegional.creditCardPercentage || 0.0,
            creditCardPerItem: 0,
            debitCardPercentage: ONLINE_LOCALITY_CONSTANT.intraRegional.debitCardPercentage || 0.0,
            debitCardPerItem: 0,
        },
        {
            name: 'interRegional',
            label: 'Inter Regional',
            creditCardPercentage:
                ONLINE_LOCALITY_CONSTANT.interRegional.creditCardPercentage || 0.0,
            creditCardPerItem: ONLINE_LOCALITY_CONSTANT.interRegional.creditCardPerItem || 0.0,
            debitCardPercentage: ONLINE_LOCALITY_CONSTANT.interRegional.debitCardPercentage || 0.0,
            debitCardPerItem: ONLINE_LOCALITY_CONSTANT.interRegional.debitCardPerItem || 0.0,
        },
    ];

    const LOCALITY_OPTIONS = [
        {
            name: 'intraRegional',
            label: 'Intra Regional',
            creditCardPercentage: LOCALITY_CONSTANT.intraRegional.creditCardPercentage || 1,
            creditCardPerItem: 0,
            debitCardPercentage: LOCALITY_CONSTANT.intraRegional.debitCardPercentage || 1,
            debitCardPerItem: 0,
        },
        {
            name: 'interRegional',
            label: 'Inter Regional',
            creditCardPercentage: LOCALITY_CONSTANT.interRegional.creditCardPercentage || 1.25,
            creditCardPerItem: LOCALITY_CONSTANT.interRegional.creditCardPerItem || 6.5,
            debitCardPercentage: LOCALITY_CONSTANT.interRegional.debitCardPercentage || 1.25,
            debitCardPerItem: LOCALITY_CONSTANT.interRegional.debitCardPerItem || 6.5,
        },
    ];
    let additionalChrgesType = [];
    if (serviceType && serviceType === 'ONLINE') {
        additionalChrgesType = ONLINE_LOCALITY_OPTIONS;
    } else {
        additionalChrgesType = LOCALITY_OPTIONS;
    }
    return (
        <Box>
            <Typography fontSize="24px" color="#434341" marginBottom="8px">
                Locality
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />

            {additionalChrgesType &&
                additionalChrgesType.map((option) => {
                    return (
                        <CustomGridItem
                            key={option.name}
                            item1={<Typography>{option.label}</Typography>}
                            item2={
                                <Flex gap="24px">
                                    <PercentageInput
                                        name={`${name}.${option.name}.creditCardPercentage`}
                                        disabled
                                    />
                                    <TransactionChargeValueNonEditable
                                        fieldName={`${name}.${option.name}.creditCardPerItem`}
                                    />
                                </Flex>
                            }
                            item3={
                                <Flex gap="24px">
                                    <PercentageInput
                                        name={`${name}.${option.name}.debitCardPercentage`}
                                        disabled
                                    />
                                    <TransactionChargeValueNonEditable
                                        fieldName={`${name}.${option.name}.debitCardPerItem`}
                                    />
                                </Flex>
                            }
                        />
                    );
                })}
        </Box>
    );
};

export default Locality;
